import type { BuildingView } from '@aztec-realms/shared-types';

/** Presentation only: the server revalidates the selected instance and target. */
export function personalGoalOptions(buildings: readonly BuildingView[]) {
  return buildings.flatMap((building) => {
    const target =
      building.state === 'constructing'
        ? building.constructionTargetLevel
        : building.maxLevel !== undefined && building.level < building.maxLevel
          ? building.level + 1
          : undefined;
    if (target === undefined) return [];
    return [
      {
        building,
        target,
        label:
          building.state === 'constructing'
            ? `Finish ${building.label} · level ${target}`
            : `Upgrade ${building.label} · level ${building.level} → ${target}`,
      },
    ];
  });
}
